// extracted by css-extract-rspack-plugin
export default {"dialog":"dialog-mKFCqD","body":"body-T1lFfF"};